import { useEffect, useState } from 'react';
import { EVAL_REVIEWS_CHANGED_EVENT, loadUnscoredReportCount } from './reportQueueApi';

/**
 * Number of unscored evals for the nav badge, or null until it's known (or if
 * loading fails, so the nav never shows a wrong count). Refreshes whenever an
 * eval is marked scored.
 */
export default function useUnscoredReportCount() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let active = true;

    function refresh() {
      loadUnscoredReportCount()
        .then((next) => { if (active) setCount(next); })
        .catch((err) => {
          console.error('Error loading unscored report count:', err);
          if (active) setCount(null);
        });
    }

    refresh();
    window.addEventListener(EVAL_REVIEWS_CHANGED_EVENT, refresh);
    return () => {
      active = false;
      window.removeEventListener(EVAL_REVIEWS_CHANGED_EVENT, refresh);
    };
  }, []);

  return count;
}
